import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, { FEATURE_FLAGS } from "../../../../constants/Define";
import VinWonderList from './VinWonderList';

let permisionActions = [];
class VinWonders extends Component {

    state = {
        filters: {
            pageSize: this.props.vinWondersState.pageSize,
            pageIndex: this.props.vinWondersState.pageIndex,
        }
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.VIN_WONDERS);
        this.props.onListVinWonder(this.state.filters);
        this.props.getVinWonderSites();
    }

    render() {
        const { t } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, vinWonders, vinWonderSites } = this.props.vinWondersState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'vinWonders'}
                        titleHeader={t('navigation.vinWonders')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Link to={`/vin-wonders/action`}
                                    className='btn btn-primary'>+ {t(`action.create`)}</Link>
                            }
                            </Fragment>
                        }
                    />
                    <VinWonderList loading={isFetching}
                                  permisions={permisionActions}
                                  vinWonders={vinWonders}
                                  vinWonderSites={vinWonderSites}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDelete={this.onDeleteVinWonder}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    

    onChangeLanguage = () => {
        this.props.onListVinWonder(this.state.filters);
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        this.props.onListVinWonder(newFilters);
    };

    onDeleteVinWonder = (item) => {
        this.props.onDeleteVinWonder(item, {
            filters: {
                pageSize: this.props.vinWondersState.pageSize,
                pageIndex: this.props.vinWondersState.pageIndex
            }
        });
    }
}


export default VinWonders;
